<div *ngIf="loading" class="loading-overlay">
  <div class="spinner">
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
  </div>
  <h2 class="loading-text">Getting everything ready...</h2>
</div>
